// src/lib/offlineDB.js
// --- INDEXEDDB: GEMERKTE ANMELDUNG -------------------------------------------
// Nur noch localSession (useAuth, Offline-Start). Protokolle und Eingaben
// liegen seit v52 in der Warteschlange (lib/warteschlange.js); die alten
// Speicher "protokolle" und "sync_queue" werden nicht mehr benutzt, bleiben
// aber in der Datenbank-Definition, damit vorhandene Geraete nicht neu anlegen.

const DB_NAME = 'etb_offline_v1';
const DB_VERSION = 2;
const STORE_PROTOKOLLE = 'protokolle';
const STORE_SYNC_QUEUE = 'sync_queue';
const STORE_USER = 'user_session';

// DB öffnen / initialisieren - EINE Verbindung fuer alle Aufrufe. Vorher
// oeffnete jeder Aufruf eine neue und schloss sie nie.
let verbindung = null;
function openDB() {
  if (verbindung) return verbindung;
  verbindung = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onerror = () => reject(req.error);
    req.onsuccess = () => resolve(req.result);
    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      // Protokolle Store
      if (!db.objectStoreNames.contains(STORE_PROTOKOLLE)) {
        const store = db.createObjectStore(STORE_PROTOKOLLE, { keyPath: 'id' });
        store.createIndex('status', 'status');
        store.createIndex('geaendert_am', 'geaendert_am');
        store.createIndex('zugewiesen_an_id', 'zugewiesen_an_id');
      }
      // Sync-Queue Store (ausstehende Uploads)
      if (!db.objectStoreNames.contains(STORE_SYNC_QUEUE)) {
        const q = db.createObjectStore(STORE_SYNC_QUEUE, {
          keyPath: 'queueId', autoIncrement: true,
        });
        q.createIndex('protokollId', 'protokollId');
        q.createIndex('timestamp', 'timestamp');
      }
      // User Session Store
      if (!db.objectStoreNames.contains(STORE_USER)) {
        db.createObjectStore(STORE_USER, { keyPath: 'key' });
      }
    };
  });
  verbindung.catch(() => { verbindung = null; });
  return verbindung;
}

// --- USER SESSION (lokal gecacht) --------------------------------------------
export const localSession = {
  save: async (userData) => {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_USER, 'readwrite');
      const req = tx.objectStore(STORE_USER).put({ key: 'current', ...userData });
      req.onsuccess = () => resolve();
      req.onerror = () => reject(req.error);
    });
  },

  get: async () => {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_USER, 'readonly');
      const req = tx.objectStore(STORE_USER).get('current');
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
  },

  clear: async () => {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_USER, 'readwrite');
      const req = tx.objectStore(STORE_USER).delete('current');
      req.onsuccess = () => resolve();
      req.onerror = () => reject(req.error);
    });
  },
};
